import React, { useState } from 'react'
import initialFAQs from 'utils/refer-faqs'
import { Link } from 'gatsby'

import MetaTags from 'components/MetaTags'
import Layout from 'layouts/Layout'
import Header from 'components/refer/Header'
import Steps from 'components/refer/Steps'
import Promo from 'components/refer/Promo'
import Share from 'components/refer/Share'
import Faq from 'components/vype-plus/Faq'

const PassOnTheSavings = () => {
  const [faqs, setFaqs] = useState(initialFAQs)

  const setCategoryExpanded = (i, expanded) => {
    let newFaqs = [...faqs]
    newFaqs[i].expanded = expanded
    setFaqs(newFaqs)
  }

  const setQuestionExpanded = (i, j, expanded) => {
    let newFaqs = [...faqs]
    newFaqs[i].content[j].expanded = expanded
    setFaqs(newFaqs)
  }

  return (
    <Layout hideHeader>
      <MetaTags
        title="Pass on the Savings | Start Saving with Vuse"
        description="Pass on $20 in savings to a family member or friend. After they make a purchase, you will get $20 in savings of your own!"
      />
      <div
        css={`
          background: #14191d;
        `}
      >
        <Header />
        <Steps />
        <Promo />
        <Share />

        <Faq
          faqs={faqs}
          setCategoryExpanded={setCategoryExpanded}
          setQuestionExpanded={setQuestionExpanded}
          title="Frequently Asked Questions"
          disclaimer={
            <span>
              For full terms and conditions of the Pass On The Savings program,{' '}
              <Link to="/pages/savings-terms-and-conditions/">click here</Link>.
            </span>
          }
          full
        />
      </div>
    </Layout>
  )
}

export default PassOnTheSavings
